import { Marquee, loop } from 'dynamic-marquee'

const SELECTOR = '[data-module="marquee"]'

export default function () {
  Array.from(document.querySelectorAll(SELECTOR)).forEach(init)
}

function init ($element) {
  const text = $element.textContent
  $element.textContent = ''
  const marquee = new Marquee($element, { rate: -160 })

  loop(marquee, [
    () => {
      var child = document.createElement('span')
      child.style.display = 'inline-block'
      child.style.paddingRight = '100vw'
      child.textContent = text
      return child
    }
  ])
}
